import React from "react";
import { FiSearch, FiRefreshCw } from "react-icons/fi";
import { SimpleDropdown } from "../../../components/common/SimpleDropdown";

const roleOptions = [
  { value: "all", label: "All" },
  { value: "player", label: "Player" },
  { value: "coach", label: "Coach" },
  { value: "scout", label: "Scout" },
];

export const ProfileVerificationsHeader = ({
  search,
  onSearchChange,
  role,
  onRoleChange,
  onRefresh,
  loading = false,
}) => (
  <>
    <h2 className="text-jp-accent-ink text-sm font-bold uppercase tracking-widest mb-3 text-left md:text-left">
      PROFILE VERIFICATIONS
    </h2>

    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-2">
      {/* Left: search */}
      <div className="flex flex-col gap-2 w-full md:max-w-md">
        <div className="relative">
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-jp-muted">
            <FiSearch size={16} />
          </span>
          <input
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Search by name or email"
            className="w-full h-9 pl-9 pr-8 rounded-lg bg-jp-card border border-jp-line text-xs text-jp-ink placeholder:text-jp-muted focus:outline-none"
          />
        </div>
      </div>

      {/* Right: refresh + role */}
      <div className="flex items-center gap-5 text-[11px] text-jp-ink">
        <button
          onClick={onRefresh}
          disabled={loading}
          className={`flex items-center gap-1 transition-colors ${loading ? 'text-sky-600 dark:text-sky-400 cursor-not-allowed' : 'hover:text-jp-accent'}`}
        >
          <FiRefreshCw size={14} className={loading ? 'animate-spin' : ''} />
          <span>{loading ? 'Loading...' : 'Refresh'}</span>
        </button>

        <div className="flex items-center gap-2">
          <span>Role</span>
          <SimpleDropdown
            value={role}
            onChange={onRoleChange}
            options={roleOptions}
            placeholder="All"
            variant="admin"
          />
        </div>
      </div>
    </div>
  </>
);
